import React from "react";

export const RYPHeader = (props) => {
    return (
        <>
            <thead className={"bp-report-thead"}>
            <tr className={"bp-report-thead-tr"}>
                <th rowSpan={3} className={"bp-report-thead-th"}>Cây báo cáo</th>
                <th colSpan={2} className={"bp-report-thead-th"}>Ngày { props?.inputDay }</th>
                <th colSpan={2} className={"bp-report-thead-th"}>MTD</th>
                <th colSpan={2} className={"bp-report-thead-th"}>YTD</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th colSpan={2}>Phí bảo hiểm tái tục đã thu</th>
                <th colSpan={2}>Phí bảo hiểm tái tục đã thu</th>
                <th colSpan={2}>Phí bảo hiểm tái tục đã thu</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th>Hợp đồng</th>
                <th>RYP</th>
                <th>Hợp đồng</th>
                <th>RYP</th>
                <th>Hợp đồng</th>
                <th>RYP</th>
            </tr>
            </thead>
        </>
    )
}

export default  RYPHeader;